// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__17stG","file":"styles_file__js0qF"};